import { CommandQueue, CommandHandler } from '../command-queue'

export class DualCommandQueue {

  private localQueue: CommandQueue;
  private remoteQueue: CommandQueue;

  constructor(prefix: string) {
    this.remoteQueue = new CommandQueue(prefix + '-remote');
    this.localQueue = new CommandQueue(prefix + '-local');
  }

  enqueueLocal(debugName: string, command: CommandHandler) {
    this.localQueue.queue(debugName, command)
  }

  enqueueRemote(debugName: string, command: CommandHandler) {
    this.remoteQueue.queue(debugName, command)
  }

  public start() {
    this.remoteQueue.start();
    this.localQueue.start();
  }

  public async stop() {
    const promises = [
      this.remoteQueue.stop(),
      this.localQueue.stop()
    ]

    await Promise.all(promises)
  }
}
